import { createStyles, makeStyles, Theme, IconButton } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useShowContext } from 'react-admin'
import { Print } from '@material-ui/icons'
import Button from '../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../hooks/useHasAuthority'
import { Authority } from '../../../core/auth/Authority'
import { ResourceName } from '../../../core/ResourceName'
import ticketProvider from '../../../core/tickets/tickets.provider'
import printLayoutsProvider from '../../../core/print-layouts/print-layouts/print-layouts.provider'
import { TicketDto } from '../../../core/dto/ticket.dto'
import { PrintBarcodeTicketDialog } from '../BookingDialogs'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.common.white,
      margin: '2px',
    },
  }),
)

export const PrintBarcodeTicketButton = ({ ...props }) => {
  const { bookingId, ticket, useIconButton = false } = props
  const { loading } = useShowContext<TicketDto>()
  const [noteDialogOpen, setNoteDialogOpen] = useState(false)
  const [note, setNote] = useState<string>()
  const hasAuthority = useHasAuthority()
  const [ticketToPrintId, setTicketToPrintId] = useState<number>(0)
  const classes = useStyles()

  const handleOpenDialog = () => {
    setNoteDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setNote(undefined)
    setNoteDialogOpen(false)
  }

  useEffect(() => {
    if (ticket) {
      setTicketToPrintId(ticket.id)
    } else if (bookingId) {
      ticketProvider
        .getList(ResourceName.TICKETS, {
          filter: {
            bookingId,
            ticketType: 'K',
          },
          sort: {
            field: 'id',
            order: 'DESC',
          },
          pagination: {
            page: 1,
            perPage: 1,
          },
        })
        .then((response) => {
          if (response?.data?.[0]?.id)
            setTicketToPrintId(response.data[0].id as number)
        })
    }
  }, [ticket, ticketToPrintId, bookingId])

  const handlePrintBarcodeTicket = async () => {
    const response = await printLayoutsProvider.printTickets(
      ResourceName.PRINT_LAYOUTS,
      {
        ticketsConditions: `t=>t.Id==${ticketToPrintId}`,
        printLayoutId: 1,
      },
    )
    const blob = response?.data?.blob?.body

    const url = window.URL.createObjectURL(blob)
    window.open(url)
  }

  return (
    <>
      <PrintBarcodeTicketDialog
        open={noteDialogOpen}
        close={handleCloseDialog}
        note={note}
        setNote={setNote}
        handleOpen={handlePrintBarcodeTicket}
      />
      {useIconButton ? (
        <IconButton
          onClick={handleOpenDialog}
          disabled={
            loading ||
            !ticketToPrintId ||
            !hasAuthority(Authority.PRINT_LAYOUTS_PRINT_TICKET)
          }
        >
          <Print />
        </IconButton>
      ) : (
        <Button
          disabled={
            loading ||
            !ticketToPrintId ||
            !hasAuthority(Authority.PRINT_LAYOUTS_PRINT_TICKET)
          }
          className={classes.button}
          variant="contained"
          onClick={handleOpenDialog}
          label="resources.bookings.actions.printBarcodeTicket"
          useSmallVersionBreakpoint={false}
        />
      )}
    </>
  )
}
